import OtpPopUp from './OtpPopUp'

export default OtpPopUp
